<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 300px;">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">机构</div>
            <el-select v-model="institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%;">
              <el-option
                  v-for="item in arr_ins"
                  :key="item.institutionCode"
                  :label="item.userName"
                  :value="item.institutionCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">项目分类</div>
            <el-select v-model="bedGoodsClassCode" filterable clearable placeholder="请选择项目分类" style="width: 100%">
              <el-option
                  v-for="item in bedGoodsClassList"
                  :key="item.bedGoodsClassCode"
                  :label="item.name"
                  :value="item.bedGoodsClassCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">改造项目名称</div>
            <el-input v-model="edit_Name" placeholder="请输入改造项目名称"></el-input>
          </el-col>

          <el-col :span="12" class="item">
            <div class="label">状态</div>
            <el-select v-model="edit_status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
              <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>

        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: ['arr_ins'],
  data() {
    return {

      loading: false,

      edit_Name:'',

      statusArr: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '禁用'
      }],
      edit_status: -1,

      bedGoodsClassList:[],
      bedGoodsClassCode:'',

      bedGoodsCode :'',
      institutionCode:'',


    }
  },
  methods: {

    init(row){

      this.edit_Name = row.name;
      this.edit_status = row.status;
      this.bedGoodsClassCode = row.bedGoodsClassCode;
      this.bedGoodsCode = row.bedGoodsCode;
      this.institutionCode = row.institutionCode;

      this.getClassList();

    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    insChange(val){
      this.institutionCode = val;

      this.bedGoodsClassList = [];
      this.bedGoodsClassCode = '';
      this.getClassList();
    },

    confirm(){

      if(this.institutionCode === ''){
        this.$message("请选择机构");
        return;
      }
      if(this.bedGoodsClassCode === ''){
        this.$message("请选择项目分类");
        return;
      }

      if(this.edit_Name === ''){
        this.$message("输入项目名称");
        return;
      }

      if(this.edit_status === -1){
        this.$message("选择状态");
        return;
      }



      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BedGoods/GovEditIns',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          name: this.edit_Name,
          status:this.edit_status,
          bedGoodsClassCode:this.bedGoodsClassCode,
          bedGoodsCode:this.bedGoodsCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },

    changeStatus:function (selVal) {
      this.edit_status = selVal;
    },

    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BedGoodsClass/GovList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.bedGoodsClassList = response.data.data;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
